import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";

/**
 * Use Case: Get Public PASCO Filter Options
 * Retrieves filter options for public PASCOs
 */
export class GetPublicPascoFilterOptionsUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    async execute(): Promise<{
        course_codes: string[];
        semesters: number[];
        academic_years: string[];
    }> {
        return this.pascoRepository.getPublicPascoFilterOptions();
    }
}